
try {
    window.$ = window.jQuery = require('jquery');
    window.$.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    window.ajaxFails = (jqXHR) => {
        if(jqXHR && jqXHR.statusText == 'abort') { return } // Cause by manual abort, no need show error
        let json = JSON.parse(jqXHR.responseText);
        if (json["message"] == "The given data was invalid." && json["errors"]) {
            // Example format of errors
            // "errors":{"email":["The email must be a valid email address."]}
            if (json["errors"]) {
                const firstKey = Object.keys(json["errors"])[0]
                alert(json["errors"][firstKey][0])
            }
        }
        else if (json["message"]) {
            alert(json["message"]);
        }
        else {
            alert(json[Object.keys(json)[0]]);
        }
    }

    window.moment = require('moment');
} catch (e) { }